import { Pipe, PipeTransform } from '@angular/core';

import { applyNumberFormat } from '../../_core/helpers/number-format.helper';
import { GlobalConfigService } from '../../_core/services/global-config.service';

@Pipe({
  name: 'numberFormat',
  pure: false,
})
export class NumberFormatPipe implements PipeTransform {
  constructor(private globalConfigService: GlobalConfigService) {}
  transform(value: string | null, ...args: unknown[]): unknown {
    if (value === null) {
      return value;
    }
    const config = this.globalConfigService.getGlobalConfig();
    if (!config || !config.numberFormat) {
      return value;
    }
    const { decimalSymbol, digitGroupingSymbol, digitGrouping } = config.numberFormat;
    return applyNumberFormat(value, decimalSymbol, digitGroupingSymbol, digitGrouping);
  }
}
